import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__add-text-to-field';
export class AddTextToField {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        this.initActions($elements);
    }
    static initActions($elements) {
        $elements.on('click', e => {
            const $element = $(e.currentTarget);
            const $target = $($element.data('target'));
            const text = $element.data('text');
            $target.val(`${$target.val() + text}`);
            $target.trigger('focus');
        });
    }
}
